import { lazy } from "react";

const Auth = [
  {
    path: "/admin/login",
    acl: "login",
    component: lazy(() =>
      import("@src/views/BackOffice/authentification/Login")
    ),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/admin/forgot-password",
    acl: "forgot_password",
    component: lazy(() =>
      import("@src/views/BackOffice/authentification/ForgotPassword")
    ),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/admin/invite/:room/:userid",
    acl: "invitation-guest",
    component: lazy(() => import("@src/views/BackOffice/studio/guest")),
    layout: "BlankLayout",
  },
];

export default Auth;
